<template>
  <div>
    <div
      id="payment-method-messaging-element"
      class="min-h-6.5 w-full pb-[5px] text-white"
    />

    <p class="text-xs">
      <NuxtLink
        class="underline text-white"
        target="_blank"
        :to="localePath('/financing-and-leasing')"
      >
        View Other Financing Options
      </NuxtLink>
    </p>
  </div>
</template>

<script setup lang="ts">
const localePath = useLocalePathPolyfill();
</script>
